var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.4787L11.39 12.8187C11.72 12.3587 12.37 12.2687 12.81 12.6187L21 18.9787V19.4787C21 20.0287 20.55 20.4787 20 20.4787H4C3.45 20.4787 3 20.0287 3 19.4787V13.7587C3.22 13.7587 3.44 13.8287 3.62 13.9787L8 17.4787ZM3 11.4787C3.44 11.4787 3.88 11.6287 4.25 11.9187L7.62 14.6087L10.39 10.7987C11.05 9.88867 12.34 9.69867 13.24 10.3987L21 16.4487V8.47867C21 7.92867 20.55 7.47867 20 7.47867H17L12.82 4.13867C12.37 3.77867 11.72 3.86867 11.38 4.33867L7 10.4787L3.6 7.92867C3.42 7.79867 3.21 7.72867 3 7.72867V11.4787Z",
    fill: "#7D30E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsIcon);
export default __webpack_public_path__ + "static/media/metrics_icon.a9a6f5bb.svg";
export { ForwardRef as ReactComponent };